export default __webpack_public_path__ + "static/media/36I-102759_-37331_0.986c747c.jpg";